import { Uuid } from "@/domains/global/identifiers";
import type { AssistantProjectModelData } from "@/store/assistant/types";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { computed, makeObservable, observable } from "mobx";

export class AssistantProjectObservable extends BaseSyncModel<AssistantProjectModelData> {
  public modelKind = SyncModelKind.AssistantProject;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<AssistantProjectModelData> } & WithAppStore) {
    super({ id, data, store });
    makeObservable(this, {
      modelKind: observable,
      assistantId: computed,
      title: computed,
      description: computed,
      status: computed,
      lastActivityAt: computed,
      createdAt: computed,
      updatedAt: computed,
    });
  }

  get assistantId(): Uuid {
    return this.modelData.assistant_id;
  }

  get title(): string {
    return this.modelData.title;
  }

  get description(): string | null {
    return this.modelData.description;
  }

  get status(): string {
    return this.modelData.status;
  }

  get lastActivityAt(): string | null {
    return this.modelData.last_activity_at;
  }

  get createdAt(): string {
    return this.modelData.created_at;
  }

  get updatedAt(): string {
    return this.modelData.updated_at;
  }
}
